import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import {
  ClaimRoundInBookingByIdInput,
  useCustomerJoinPaidBookingMutation,
} from "./__generated__/useCustomerJoinPaidBookingMutation.graphql";

export const useCustomerJoinPaidBooking = () => {
  const [joinBookingMutation, isJoiningPaidBooking] =
    useMutation<useCustomerJoinPaidBookingMutation>(
      useCustomerJoinPaidBookingMutationString
    );

  const handleCustomerJoinPaidBooking = (
    input: ClaimRoundInBookingByIdInput,
    handleJoinSuccess: (slotOrBookingId: string) => void,
    handleJoinError: () => void
  ) => {
    joinBookingMutation({
      variables: { input },
      onCompleted: (response, errors) => {
        if (
          response?.claimRoundInBookingById?.success &&
          response?.claimRoundInBookingById?.booking?.id
        ) {
          handleJoinSuccess(response.claimRoundInBookingById.booking.id);
        } else {
          //Show error toast.
          handleJoinError();
        }
      },
      onError: (error) => {
        //Show error toast.
        handleJoinError();
      },
    });
  };

  return { handleCustomerJoinPaidBooking, isJoiningPaidBooking };
};

export const useCustomerJoinPaidBookingMutationString = graphql`
  mutation useCustomerJoinPaidBookingMutation(
    $input: ClaimRoundInBookingByIdInput!
  ) {
    claimRoundInBookingById(input: $input) {
      success
      errors {
        field
        code
        message
      }
      booking {
        id
      }
    }
  }
`;
